<template>
  <div class="tick-icon" :style="tickStyles" />
</template>

<script>
export default {
  name: 'TickIcon',
  props: {
    borderWidth: {
      type: String,
      default: '2px'
    },
    borderColor: {
      type: String,
      default: '#1370FF'
    }
  },
  computed: {
    tickStyles () {
      return {
        borderBottom: `${this.borderWidth} solid ${this.borderColor}`,
        borderRight: `${this.borderWidth} solid ${this.borderColor}`
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .tick-icon {
    height: 18px;
    width: 10px;
    bottom: 3px;

    @media(min-width: $screen-md) {
      height: 24px;
      width: 12px;
      bottom: 5px;
    }

    display: inline-block;
    transform: rotate(45deg);
    position: relative;
  }
</style>
